import React from 'react';
import './phone.css';
import screen1x1 from './screen1-1x.jpg';
import screen1x2 from './screen1-2x.jpg';
import screen2x1 from './screen2-1x.jpg';
import screen2x2 from './screen2-2x.jpg';
import screen3x1 from './screen3-1x.jpg';
import screen3x2 from './screen3-2x.jpg';
import screen4x1 from './screen4-1x.jpg';
import screen4x2 from './screen4-2x.jpg';
import slidingMinix1 from './screen5-mini-1x.jpg';
import slidingMinix2 from './screen5-mini-2x.jpg';
import slidingx1 from './screen3-1x.jpg';
import slidingx2 from './screen3-2x.jpg';

const imgs = [{
	x1: screen1x1,
	x2: screen1x2
}, {
	x1: screen2x1,
	x2: screen2x2
}, {
	x1: screen3x1,
	x2: screen3x2
}, {
	x1: screen4x1,
	x2: screen4x2
}, {
	x1: slidingMinix1,
	x2: slidingMinix2
}, {
	x1: slidingx1,
	x2: slidingx2
}];

const Phone = (props) => {
	const {opacity, indexImages} = props;
	const src = imgs[indexImages];
	return (
		<div className="phone">
			<svg className="phone__img" xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 600 1000">
				<filter id="blur-filter" x="-15" y="-1" width="560" height="1000">
					<feGaussianBlur in="SourceGraphic" stdDeviation="25"/>
				</filter>
				<path
					d="M508.2,178.6a.1.1,0,0,0-.1-.1,4.35,4.35,0,0,0-.6-.7l-.1-.1a5.28,5.28,0,0,0-2.4-1,3.4,3.4,0,0,0-1-.1h-.1V68.3A68.52,68.52,0,0,0,435.6,0H71.2C33.6,0,2.8,30.8,2.8,68.3V105H1.9c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2-.2.1-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a.91.91,0,0,0-.3.7v27.7c0,.2.1.5.1.7s.1.1.1.2.1.2.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.9V164H1.9c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2-.2.1-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a1.48,1.48,0,0,0-.1.7v55.9c0,.2.1.5.1.7s.1.1.1.2.1.2.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.9v15.8H2.6c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2l-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a1.48,1.48,0,0,0-.1.7v55.9c0,.2.1.5.1.7s.1.1.1.2.1.3.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.2V899.3a68.52,68.52,0,0,0,68.3,68.3H435.4a68.52,68.52,0,0,0,68.3-68.3V279h.1a5.72,5.72,0,0,0,3.4-1l.1-.1a1.87,1.87,0,0,0,.6-.7.1.1,0,0,1,.1-.1,2.92,2.92,0,0,0,.2-.9V179.5A1,1,0,0,0,508.2,178.6Z"
					fill="#000" filter="url(#blur-filter)" opacity=".15" transform="translate(0 40)"/>
				<path
					d="M508.2,178.6a.1.1,0,0,0-.1-.1,4.35,4.35,0,0,0-.6-.7l-.1-.1a5.28,5.28,0,0,0-2.4-1,3.4,3.4,0,0,0-1-.1h-.1V68.3A68.52,68.52,0,0,0,435.6,0H71.2C33.6,0,2.8,30.8,2.8,68.3V105H1.9c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2-.2.1-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a.91.91,0,0,0-.3.7v27.7c0,.2.1.5.1.7s.1.1.1.2.1.2.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.9V164H1.9c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2-.2.1-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a1.48,1.48,0,0,0-.1.7v55.9c0,.2.1.5.1.7s.1.1.1.2.1.2.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.9v15.8H2.6c-.2,0-.3.1-.4.1h0c-.1,0-.1,0-.1.1s-.2.1-.3.1-.2.1-.3.2l-.2.2a.52.52,0,0,0-.2.4c0,.1-.1.1-.1.2a1.48,1.48,0,0,0-.1.7v55.9c0,.2.1.5.1.7s.1.1.1.2.1.3.2.4l.2.2c.1.1.2.1.3.2a.37.37,0,0,0,.3.1.1.1,0,0,1,.1.1h0c.1,0,.3.1.4.1h.2V899.3a68.52,68.52,0,0,0,68.3,68.3H435.4a68.52,68.52,0,0,0,68.3-68.3V279h.1a5.72,5.72,0,0,0,3.4-1l.1-.1a1.87,1.87,0,0,0,.6-.7.1.1,0,0,1,.1-.1,2.92,2.92,0,0,0,.2-.9V179.5A1,1,0,0,0,508.2,178.6Z"
					fill="#dadae5" opacity={opacity || 1}/>
				<path
					d="M427.6,24.5H385.2c-1.5,1-2.5,3-3.4,4.4h0a25.73,25.73,0,0,1-25.5,22.7H148.9a25.79,25.79,0,0,1-25.6-23h0a11.62,11.62,0,0,0-3.3-4H77.1A52.37,52.37,0,0,0,24.9,76.8v813A52.37,52.37,0,0,0,77.1,942H427.6a52.37,52.37,0,0,0,52.2-52.2V76.8A52.39,52.39,0,0,0,427.6,24.5Z"
					fill="#fff"/>
			</svg>
			<div className="phone__img phone__img--content">
				{src && <img className='phone__content' src={src.x1} srcSet={`${src.x2} 2x`} alt="Interest content"/>}
			</div>
		</div>
	);
};

export default Phone;



// WEBPACK FOOTER //
// ./src/components/Phone/Phone.js